<div class="inside-container" *ngIf="code">
    <div fxLayout="row">
        <div fxFlex="70" fxLayoutAlign="start center">
            <h3 class="tab-header" i18n="@@5440621494316196618" t="5440621494316196618">EDI Status</h3>
        </div>
    </div>

    <div class="edi-status-grid">    
        <div>
            <table tsl-table [dataSource]="gridViewData">
                <ng-container tslColumnDef="EDI">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@EDI" t="EDI" [width]="75"> EDI </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element?.displayTitle; else empty">{{element?.displayTitle}}</div>
                    </td>
                </ng-container>
                <ng-container tslColumnDef="STATUS">
                    <th tsl-header-cell *tslHeaderCellDef i18n="@@7317862172436611655" t="7317862172436611655" [width]="75"> STATUS </th>
                    <td tsl-cell *tslCellDef="let element">
                        <div *ngIf="element?.displayStatus; else empty">{{element?.displayStatus}}</div>
                    </td>
                </ng-container>
                <tr tsl-header-row *tslHeaderRowDef="displayedColumns"></tr>
                <tr tsl-row *tslRowDef="let row; columns: displayedColumns;"></tr>
                <ng-template #empty>
                    <tsl-icon>maximize</tsl-icon>
                </ng-template>
            </table>
            <div>
                <tsl-pagination [pageSizeOptions]="pageSizeOptions" showFirstLastButtons (pageChange)="pageChange($event)"
                  [total]="totalRows" [itemsPerPageLabel]="translateService.get('ItemsPerPage')" [pageSize]="currentPageSize"></tsl-pagination>
            </div>
        </div>
    </div>
</div>
